import classNames from "classnames";

import { Typography } from "../Typography";
import styles from "./Heading2.module.scss";

export const Heading2 = ({
  as = "h2",
  className,
  color,
  children,
  plain = false,
}) => (
  <Typography
    className={classNames(className, styles.element)}
    color={color}
    as={as}
    plain={plain}
  >
    {children}
  </Typography>
);
